<template>
    <router-link to="/messages">
        <v-badge
            id="message-badge"
            :color="userMessagesView.unread > 0 ? '#F26227' : 'transparent'"
            overlap
            offset-x="24"
            offset-y="24"
            :content="userMessagesView.unread"
        >
            <v-btn icon>
                <v-icon class="material-icons-outlined">
                    email 
                </v-icon>
            </v-btn>
        </v-badge>
    </router-link>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend.js';
// const GET_USER_MESSAGES_INTERVAL = 15000;
export default {
    data() {
        return {};
    },
    computed: {
        userMessagesView() {
            return this.$store.getters.userMessagesView;
        },
    },
    created() {
        this.getMessages();
    },
    methods: {
        async getMessages() {
            let messages = await webtmsBackend.getUserMessagesView();
            this.$store.commit('SET_USER_MESSAGES_VIEW', messages);
            // setTimeout(this.getMessages, GET_USER_MESSAGES_INTERVAL);
        },
    }
};
</script>